<!-- 轨迹地图 -->
<template>
  <div class="height-percent-100 " v-if="tracableInfo.carrier">
    <div v-if="tracableInfo.carrier.lat" class="height-percent-100">
      <div :id="mapId" class="map">
        <div class="refresh-box">
          <i
            class="el-icon-refresh refresh cursor-pointer"
            :title="$t('integration.refresh')"
            @click="refresh"
            v-if="this.$attrs.tab === 'realtime'"
          ></i>
        </div>
      </div>
    </div>
    <div v-else class="border height-percent-100">
      <el-empty
        :description="$t('integration.no_action_track_detected')"
      ></el-empty>
    </div>
  </div>
</template>
<script>
import { getLanguage } from '@/lang'
import bus from '@/utils/bus'
import { mapTrackcarrierTraceState } from '@/api/modules/map'
import { marker_car, massMarkers } from '@/pages/home/config/mapIcon'

import { wgs84togcj02 } from '@/utils/postion'
import { renderTrace } from '@/utils/mapUtil'

export default {
  props: ['tracableInfo', 'mapId'],
  data () {
    return {
      flag: true,
      map: null,
      traceRecord: [],
      // 轨迹路线和海量点
      polyline: null,
      mass: null,
      activeMarker: null,
      labelMarker: null,
      marker: null
    }
  },
  watch: {
    tracableInfo: {
      immediate: true,
      handler () {
        const map = this.tracableInfo.carrier
        if (map.lng) this.getInitMap(wgs84togcj02(map.lng, map.lat), false)
      }
    }
  },
  methods: {
    async getInitMap (center, isShowIcon) {
      // [AMap removed] await lazyAMapApiLoaderInstance.load()
      // [AMap removed] const map = new AMap.Map(this.mapId, {
      // [AMap removed]   lang: getLanguage().split('_')[0],
      // [AMap removed]   resizeEnable: true,
      // [AMap removed]   center: center || [113.43403, 23.173214],
      // [AMap removed]   zoom: 12,
      // [AMap removed]   viewMode: '3D' // 使用3D视图
      // [AMap removed] })

      // 标记中心点
      // [AMap removed] if (!isShowIcon) {
      // [AMap removed]   const marker = new AMap.Marker({
      // [AMap removed]     position: center || [113.43403, 23.173214],
      // [AMap removed]     offset: new AMap.Pixel(-14, -31),
      // [AMap removed]     content: marker_car
      // [AMap removed]   })
      // [AMap removed]   this.marker = marker
      //
      // [AMap removed]   marker.setMap(map)
      // [AMap removed] }

      // [AMap removed] this.map = map
    },
    // 对外
    async renderTrace (trace = []) {
      if (this.polyline) {
        this.polyline.setMap(null)
        this.mass.setMap(null)
      }
      const { polyline, mass } = renderTrace(
        this.map,
        trace,
        this.tracableInfo.carrier.id
      )

      this.polyline = Object.freeze(polyline)
      this.mass = mass

      return
      // 清除海量点和轨迹
      if (this.polyline) {
        this.polyline.setMap(null)
        this.mass.setMap(null)
        if (this.activeMarker) {
          this.activeMarker.setMap(null)
        }
        if (this.labelMarker) {
          this.labelMarker.setMap(null)
        }
        this.polyline = null
        this.mass = null
        this.activeMarker = null
        this.labelMarker = null
      }
      // [AMap removed] await lazyAMapApiLoaderInstance.load()
      if (!trace.length) return
      const last = trace.length - 1

      // const trace = this.filterTracePoint(trace);
      this.dealTraceData(trace)

      // 设置最大级别的层级 设置第一个轨迹点为中心点
      if (this.map) {
        this.map.setZoomAndCenter(
          18,
          wgs84togcj02(trace[last].lng, trace[last].lat)
        )
      }
    },
    /**
     * 对外 渲染运输轨迹
     * @param trace 轨迹
     * @returns {Promise<void>}
     */
    async renderTransportTrace (trace = []) {
      if (this.polyline) {
        this.polyline.setMap(null)
        this.mass.setMap(null)
      }
      const { polyline, mass } = renderTrace(
        this.map,
        trace,
        this.tracableInfo.carrier.id
      )

      this.polyline = Object.freeze(polyline)
      this.mass = mass
    },

    // 对外
    filterTracePoint (trace, option, speed = {}) {
      // 无过滤
      if (option === 'filter_none') {
        trace.forEach(item => (item.filter = false))
        return trace
      }
      // 数据异常 或者离线过滤
      if (
        option === 'filter_data_ex' ||
        option === 'filter_off_ex' ||
        option === 'filter_all_ex'
      ) {
        trace.forEach((item, index) => {
          if (!item.ex) {
            return
          }
          const ex = item.ex
            .toString()
            .split('')
            .reverse()
          trace[index].filter = false

          //  只要选择其中一项都会被标记为过滤点
          switch (option) {
            case 'filter_off_ex':
              // 连接异常
              if (ex[0] === '1') trace[index].filter = true
              break
            case 'filter_data_ex':
              // 数据异常
              if (ex[1] === '1') trace[index].filter = true
              break
            case 'filter_all_ex':
              // 包括连接异常和数据异常
              if (ex[1] === '1' || ex[0] === '1') trace[index].filter = true
              break
          }
        })
      }

      // 速度过滤
      if (option === 'filter_speed') {
        if (!speed.less) {
          speed.less = -Infinity
        }
        if (!speed.greater) {
          speed.greater = Infinity
        }
        trace.forEach((item, index) => {
          if (item.speed > speed.less && item.speed < speed.greater) {
            trace[index].filter = true
          }
        })
      }
      return trace
    },
    // 构造高德地图的点 与触发高德地图渲染(transportHistory此函数不会被调用 移步至MapUtil.js)
    buildPoint (massPoint, path, raw) {
      // 传入过滤后数据和原数据

      // 海量点
      const mass = massMarkers(massPoint)
      // [AMap removed] const marker = new AMap.Marker({
      // [AMap removed]   content: ' ',
      // [AMap removed]   map: this.map
      // [AMap removed] })

      if (this.tipMarker) this.tipMarker.setMap(null)

      // 鼠标移动到哪个点 这个个点就会跟到哪里
      mass.on('mouseover', function (e) {
        // [AMap removed] marker.setPosition(e.data.lnglat)
        const markerContent = document.createElement('div')
        markerContent.className = 'map-tip'
        markerContent.innerHTML = e.data.name
        // [AMap removed] marker.setContent(markerContent)
      })

      // 轨迹
      // [AMap removed] const polyline = new AMap.Polyline({
      // [AMap removed]   path: path,
      // [AMap removed]   showDir: true,
      // [AMap removed]   strokeColor: '#28F', // 线颜色
      // [AMap removed]   // strokeOpacity: 1,     //线透明度
      // [AMap removed]   strokeWeight: 6, // 线宽
      // [AMap removed]   strokeStyle: 'solid' // 线样式
      // [AMap removed] })

      // 点击轨迹 激活图标  因为海量点实在没办法进行交互 因此只能在其上层覆盖一个Marker
      const activeMarker = null

      // 记录上一个被点击的mass的样式和对象 便于重新渲染

      const lastMass = {
        style: null,
        // 保存的是地址 浅拷贝
        target: null
      }

      mass.on('click', e => {
        e.stopPropagation()

        // 还原回原来的样式
        if (lastMass.target) {
          lastMass.target.style = lastMass.style
        }
        lastMass.style = e.data.style
        lastMass.target = e.data
        e.data.style = 1
        this.mass.setMap(this.map)

        // console.log()
        const info = e.data.info
        bus.$emit('massClick', info)
      })
      // 通知地图界面渲染路径和海量点
      // this.$emit('renderPoint', [polyline, mass]);
      // [AMap removed] this.polyline = Object.freeze(polyline)

      this.mass = mass

      // [AMap removed] polyline.setMap(this.map)
      mass.setMap(this.map)
    },
    // 处理轨迹数据
    dealTraceData (trace) {
      const mass = []
      const path = []
      if (!(trace instanceof Array)) {
        return new Error($t('integration.trace_is_not_an_array'))
      }
      // 定义海量点的属性 与路径的属性
      trace.forEach((item, index) => {
        // 已过滤的点
        if (item.filter) {
          // 附加一个id属性 获取详细轨迹信息时需要用到
          mass.push({
            lnglat: wgs84togcj02(item.lng, item.lat),
            name: this.$timetransition(item.time),
            style: 0,
            info: {
              ...item,
              id: this.tracableInfo.carrier.id
            }
          })
        } else {
          // 原路径
          mass.push({
            lnglat: wgs84togcj02(item.lng, item.lat),
            name: this.$timetransition(item.time),
            style: 2,
            info: {
              ...item,
              id: this.tracableInfo.carrier.id
            }
          })
        }
        path.push(wgs84togcj02(item.lng, item.lat))
      })

      this.buildPoint(mass, path, trace)
    },
    // 处理运输轨迹
    dealTransportTraceData (trace) {
      const mass = []
      const path = []
      if (!(trace instanceof Array)) {
        return new Error($t('integration.trace_is_not_an_array'))
      }
      // 定义海量点的属性 与路径的属性
      trace.forEach((item, index) => {
        item.index = index
        // 已过滤的点
        if (item.filter) {
          // 附加一个id属性 获取详细轨迹信息时需要用到
          mass.push({
            lnglat: wgs84togcj02(item.lng, item.lat),
            name: this.$timetransition(item.time),
            style: 0,
            info: {
              ...item,
              id: this.tracableInfo.carrier.id
            }
          })
        } else {
          // 原路径
          if (index === 0) {
            // 起点样式
            mass.push({
              lnglat: wgs84togcj02(item.lng, item.lat),
              name: this.$timetransition(item.time),
              style: 3,
              info: {
                ...item,
                id: this.tracableInfo.carrier.id
              }
            })
          } else if (index === trace.length - 1) {
            // 终点样式
            mass.push({
              lnglat: wgs84togcj02(item.lng, item.lat),
              name: this.$timetransition(item.time),
              style: 4,
              info: {
                ...item,
                id: this.tracableInfo.carrier.id
              }
            })
          } else {
            mass.push({
              lnglat: wgs84togcj02(item.lng, item.lat),
              name: this.$timetransition(item.time),
              style: item.reach ? 5 : 2,
              info: {
                ...item,
                id: this.tracableInfo.carrier.id
              }
            })
          }
        }
        path.push(wgs84togcj02(item.lng, item.lat))
      })

      this.buildPoint(mass, path, trace)
    },
    refresh () {
      mapTrackcarrierTraceState({ id: this.tracableInfo.carrier.id }).then(
        res => {
          const { lng, lat } = res.result.trace
          this.marker.setPosition(wgs84togcj02(lng, lat))
        }
      )
      this.$emit('onRefresh')
    }
  },
  mounted () {
    bus.$on('onTraceRender', (trace, carrierId) => {
      if (this.polyline) {
        this.polyline.setMap(null)
        this.mass.setMap(null)
        this.polyline = null
        this.polyline = null
      }
      const { polyline, mass } = renderTrace(this.map, trace, carrierId)
      this.polyline = polyline
      this.mass = mass
    })
  },
  beforeDestroy () {
    bus.$off('massClick')
    bus.$off('onTraceRender')
  }
}
</script>

<style scoped lang="scss">
.map {
  width: 100%;
  height: 100%;
  position: relative;

  .refresh-box {
    position: absolute;
    right: 10px;
    top: 10px;
    border-radius: 50%;
    padding: 6px;
    z-index: 999;
    background-color: rgba($color: white, $alpha: 0.6);

    &:hover {
      background-color: rgba($color: white, $alpha: 1);
    }
  }

  .refresh {
    font-size: 20px;
    font-weight: 600;
  }
}
</style>
